/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('select2/dist/js/select2.js');
require('jquery-ui');
require('hover-preview-js');
require('sumoselect');
require('inputmask/dist/inputmask.min.js');
require('inputmask/dist/jquery.inputmask.min.js');
require('trumbowyg');

import hoverPreview from 'hover-preview-js';

import $ from 'jquery';
window.$ = window.jQuery = $;
window.hoverPreview = hoverPreview;

import 'jquery-ui/ui/widgets/datepicker.js';

import icons from 'trumbowyg/dist/ui/icons.svg'
$.trumbowyg.svgPath = icons
